import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location } from '@angular/common';
import { HttpService } from 'src/app/core/services/http.service';
import { TokenService } from 'src/app/core/services/token.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { filter } from 'rxjs/operators';

const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit, OnDestroy {
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private _router: Subscription;
    branchOffices: any;
    loadingBranchOffices: boolean;
    user: any;

    @ViewChild('app-navbar-cmp', {static: false}) button: any;

    constructor(
        location: Location,
        private renderer: Renderer2,
        private element: ElementRef,
        private router: Router,
        private http: HttpService,
        private token: TokenService,
        private auth: AuthService,
    ) {
        this.location = location;
        this.nativeElement = element.nativeElement;
    }

    minimizeSidebar() {
      const body = document.getElementsByTagName('body')[0];

      // En mobile (<=991px) el botón solo abre el drawer; el cierre lo hace el
      // overlay (click fuera) o la navegación a otro ítem. En desktop colapsa/
      // expande el sidebar (mini).
      if ($(window).width() <= 991) {
        if (!body.classList.contains('nav-open')) {
          this.openMobileSidebar();
        }
        return;
      }

      if (misc.sidebar_mini_active === true) {
          body.classList.remove('sidebar-mini');
          misc.sidebar_mini_active = false;

      } else {
          setTimeout(function() {
              body.classList.add('sidebar-mini');

              misc.sidebar_mini_active = true;
          }, 300);
      }

      // we simulate the window Resize so the charts will get updated in realtime.
      const simulateWindowResize = setInterval(function() {
          window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function() {
          clearInterval(simulateWindowResize);
      }, 1000);
    }

    private openMobileSidebar() {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('nav-open');

      if (!document.querySelector('.mobile-sidebar-overlay')) {
        const overlay = document.createElement('div');
        overlay.className = 'mobile-sidebar-overlay';
        overlay.addEventListener('click', () => this.closeMobileSidebar());
        body.appendChild(overlay);
      }
    }

    private closeMobileSidebar() {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('nav-open');

      const overlay = document.querySelector('.mobile-sidebar-overlay');
      if (overlay) {
        overlay.remove();
      }
    }

    hideSidebar() {
      const body = document.getElementsByTagName('body')[0];
      const sidebar = document.getElementsByClassName('sidebar')[0];

      if (misc.hide_sidebar_active === true) {
          setTimeout(function() {
              body.classList.remove('hide-sidebar');
              misc.hide_sidebar_active = false;
          }, 300);
          setTimeout(function () {
              sidebar.classList.remove('animation');
          }, 600);
          sidebar.classList.add('animation');

      } else {
          setTimeout(function() {
            body.classList.add('hide-sidebar');
              // $('.sidebar').addClass('animation');
              misc.hide_sidebar_active = true;
          }, 300);
      }

      // we simulate the window Resize so the charts will get updated in realtime.
      const simulateWindowResize = setInterval(function() {
          window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function() {
          clearInterval(simulateWindowResize);
      }, 1000);
    }

    ngOnInit() {
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        const body = document.getElementsByTagName('body')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }

        this._router = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.sidebarClose();
        });

        this.user = this.token.get();
    }

    ngOnDestroy() {
      this.closeMobileSidebar();
      if (this._router) {
        this._router.unsubscribe();
      }
    }

    onResize(event) {
      if ($(window).width() > 991) {
        return false;
      }
      return true;
    }

    /**
     * Cierra el sidebar mobile. Punto de entrada público invocado desde
     * `admin-layout.component.ts` en cada NavigationEnd.
     */
    sidebarClose() {
      this.closeMobileSidebar();
    }

    getTitle() {
      let titlee = this.location.prepareExternalUrl(this.location.path());
      if (titlee.charAt(0) === '#') {
          titlee = titlee.slice( 1 );
      }
      if (titlee.charAt(0) === '/') {
          titlee = titlee.slice( 1 );
      }
        for (let i = 0; i < this.listTitles.length; i++) {
            const p = this.listTitles[i].path;
            const matches = titlee === p || titlee.startsWith(p + '/') || titlee.startsWith(p + ';');
            if (this.listTitles[i].type === 'link' && matches) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === 'sub') {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    const subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return 'Tablero';
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    logOut() {
        this.auth.logOut();
    }
}
